import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

import transferTypes from './utils/transferTypes';

type StatusTransferStatusProps = {
  /** The message object */
  message: any;
};

export default class StatusTransferStatus extends PureComponent<StatusTransferStatusProps> {
  constructor(props: StatusTransferStatusProps) {
    super(props);
  }

  getRecipientName(author: User | null) {
    if (!author) return null;
    const { name, phone_number, email } = author;

    if (name && name.trim().length) {
      return name;
    }
    return phone_number || email || null;
  }

  generateStatusText(
    recipient: string | null,
    type: string,
    isDelivered: boolean,
    transfer_target_name: string | null,
  ) {
    const deliveryStatus = isDelivered
      ? ' delivered'
      : ' could not be delivered';
    let targetName = transfer_target_name ? ` "${transfer_target_name}"` : '';
    if (recipient) {
      targetName = ` ${recipient}`;
    }
    return `${transferTypes.getTypeString(type)}${deliveryStatus}${
      targetName ? ` to ${targetName}` : ''
    }`;
  }

  render() {
    const { message, ...otherProps } = this.props;

    const isDelivered = message.resolved_result === 'true' || message.accepted;
    const recipient = this.getRecipientName(message.author);
    const statusText = this.generateStatusText(
      recipient,
      message.transfer_type,
      isDelivered,
      message.transfer_target_name,
    );

    return <MessageStatus {...(otherProps as any)} text={statusText} />;
  }
}
